import { mixpanelService } from '../../service/mixpanel-service'

export class MixpanelInitiate {
  public get Name(): string {
    return 'Mixpanel'
  }

  protected _destroyFn(): Promise<void> {
    return Promise.resolve(undefined)
  }

  protected async _initFn(): Promise<void> {
    await mixpanelService.init()
  }
}
